<script setup>
const props = defineProps({
  src: {
    type: String,
    required: false,
    default: '',
  },
  alt: {
    type: String,
    required: false,
    default: '',
  },
  text: {
    type: String,
    required: false,
    default: '',
  },
  classNames: {
    type: String,
    required: false,
    default: '',
  },
})

const isImageError = ref(false)

function handleImageError() {
  isImageError.value = true
}
</script>
<template>
  <div :title="text" class="wrap">
    <img v-if="src && !isImageError" :src="src" :alt="alt" @error="handleImageError" />
    <span class="imageFallback" v-else></span>
    <span class="name" v-if="text" :class="classNames">
      {{ text }}
    </span>
  </div>
</template>
<style scoped>
.wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}
img,
.imageFallback {
  max-height: 25px;
  max-width: 25px;
  width: 100%;
  height: 100%;
}
.imageFallback {
  display: inline-block;
}
.name {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
}
</style>
